import { Component, computed, inject, input, output } from '@angular/core';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { TranslatePipe } from '../../../shared/pipes/translate-pipe';
import { IconComponent } from '../../../shared/components/icon/icon.component';
import { IconName } from '../../../shared/enums/icon-enum';
import { Slide } from '../../../shared/interfaces/onboarding.inteerface';
import { OnboardingService } from '../../../core/services/onboarding.service';
import { LineBreakPipe } from '../../../shared/pipes/line-break-pipe';
import { OnboardingStepperComponent } from '../onboarding-stepper/onboarding-stepper.component';

@Component({
  selector: 'app-onboarding-slide',
  imports: [TranslatePipe, CdkStepperModule, IconComponent, LineBreakPipe],
  templateUrl: './onboarding-slide.component.html',
  styleUrl: './onboarding-slide.component.scss',
})
export class OnboardingSlideComponent {
  public onboardingData = input.required<Slide>();
  public closeDialog = output<void>();
  public readonly isLast = input<boolean>(false);
  public readonly currentIndex = input.required<number>();
  public readonly length = input.required<number>();

  public readonly lengthArray = computed(() =>
    Array.from({ length: this.length() }, (_, i) => i + 1),
  );

  private readonly onboardingService = inject(OnboardingService);
  protected readonly stepper = inject(OnboardingStepperComponent);

  public iconName = IconName;

  public onClose(): void {
    this.closeDialog.emit();
  }
  public onStart(): void {
    this.onboardingService.onboardingComplete().subscribe();
    this.closeDialog.emit();
  }

  public onCancel(): void {
    this.closeDialog.emit();
  }
}
